// extracted by mini-css-extract-plugin
module.exports = {"menuText":"#bfcbd9","menuActiveText":"#fff","subMenuActiveText":"#fff","menuBg":"#253243","menuHover":"#047BFD","subMenuBg":"\"\"","subMenuHover":"#047BFD","sideBarWidth":"210px"};